import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RoleDirective } from "./role.directive";
import { PermissionDirective } from "./permission.directive";
import { ModuleDirective } from "./module.directive";

@NgModule({
    declarations: [RoleDirective, PermissionDirective, ModuleDirective],
    imports: [CommonModule],
    exports: [RoleDirective, PermissionDirective, ModuleDirective]
})
export class AccessDirectivesModule {}
